import { getAuthorizedSellersQuery } from '@savgroup-front-common/core/api/Seller/getAuthorizedSellersQuery';
import getSellerAcceptedLanguages from '@savgroup-front-common/core/api/Seller/getSellerAcceptedLanguages';
import { getSellerByIdQuery } from '@savgroup-front-common/core/api/Seller/getSellerByIdQuery';
import { getSellerConfigurationQuery } from '@savgroup-front-common/core/api/Seller/getSellerConfigurationQuery';
import { getTenantReadinessQuery } from '@savgroup-front-common/core/api/Seller/getTenantReadinessQuery';
import { getVatRateBySellerIdQuery } from '@savgroup-front-common/core/api/Seller/getVatRateBySellerIdQuery';
import { setSellerConfigurationAcceptedLanguagesCommand } from '@savgroup-front-common/core/api/Seller/setSellerConfigurationAcceptedLanguagesCommand';
import { setSellerConfigurationAccountManagerCommand } from '@savgroup-front-common/core/api/Seller/setSellerConfigurationAccountManagerCommand';
import { setSellerConfigurationOtherCommand } from '@savgroup-front-common/core/api/Seller/setSellerConfigurationOtherCommand';
import { setSellerConfigurationTransportCommand } from '@savgroup-front-common/core/api/Seller/setSellerConfigurationTransportCommand';
import { suggestCompanyProfileCommand } from '@savgroup-front-common/core/api/Seller/suggestCompanyProfileCommand';

export const CommonSellerService = {
  getSellerConfigurationQuery,
  getSellerAcceptedLanguages,
  getVatRateBySellerIdQuery,
  getAuthorizedSellersQuery,
  getSellerByIdQuery,
  setSellerConfigurationOtherCommand,
  setSellerConfigurationTransportCommand,
  setSellerConfigurationAccountManagerCommand,
  setSellerConfigurationAcceptedLanguagesCommand,
  suggestCompanyProfileCommand,
  getTenantReadinessQuery,
};
